<div id="ey-navbar-container">
  <div id="ey-app-home" class="ey-app-home">
    <div class="ey-max-container">
      <img class="ey-bg-logo" src="assets/images/ey-bg-log-3.png" />
      <button pButton type="submit" (click)="logout()" class="d-flex ms-auto border-0 ey-btn-trans " title="Logout">
        <i class="pi pi-power-off lg-btn"></i>
      </button>
      <div id="sign-in-container" class="sign-in-container">
        <div class="admin-heading" role="heading" aria-level="1"></div>
        <div class="sub-text-container">
          @if (showError) {
            <div class="country-error-msg">
              Please select a country
            </div>
          }
          <div class="sub-text">
          </div>
        </div>
        <div id="login-btn">
          <div>
            <select id="ctrList" class="form-select me-2" (change)="onCountryChange($event)">
              <option value="default" selected id="choose" class="alert alert-danger" role="alert"
                aria-errormessage="Select a Country">
                Select a Country</option>
              <option value="IN">India</option>
              <option value="PL">Poland</option>
              <option value="RO">Romania</option>
              <option value="FR">France</option>
              <option value="JP">Japan</option>
              <option value="KSA">Kingdom of Saudi Arabia</option>
              <option value="AU">Australia</option>
              <option value="IT">Italy</option>
              <option value="MY">Malaysia</option>
              <option value="GBLD">Global-D</option>
            </select>
          </div>
          <div>
            <button pButton type="submit" class="ey-button mt-0 ey-sign-btn1" (click)='redirectDashboard()'>
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>